module.exports = "<!-- begin::Page loader -->\n<div\n  class=\"m-page-loader m-page-loader--non-block\"\n  style=\"margin-left: -80px; margin-top: -20px;\">\n  <div class=\"m-blockui\">\n    <span> {{ this.appService.loadingMessage }}... </span>\n    <span>\n      <div class=\"m-loader m-loader--brand\"></div>\n    </span>\n  </div>\n</div>\n<!-- end::Page loader -->\n<!-- begin:: Page -->\n<router-outlet></router-outlet>\n<!-- end:: Page -->\n<app-quick-sidebar></app-quick-sidebar>\n<app-scroll-top></app-scroll-top>\n"


//////////////////
// WEBPACK FOOTER
// /mnt/volume_sfo2_01/www/html/anbe-dev/src/app/app.component.html
// module id = ../../../../../src/app/app.component.html
// module chunks = main